import type Login from "../routes/Login.svelte";
import { onDestroy } from "svelte";
import type { ApiService, RequestCalculateResultsResponse, CheckResultsStatusResponse, GetAssessmentResponse, LoginResponse, OtpResponse, StoreHipaaResponse, UpdateAssessmentResponse } from "./ApiService";
import { Assessment, AuthenticationResponse, Configuration } from "./assesment";
import { AssessmentApi, AuthenticateApi } from "./assesment";
import { userState } from "../modules/store";
export class DefaultApiService implements ApiService {
    private authApi: AuthenticateApi;
    private assessmentApi: AssessmentApi;
    private currentUserState=null;
    private subscriber;
    constructor() {
        var c = new Configuration({basePath:window.location.origin});
        this.authApi = new AuthenticateApi(c);
        this.assessmentApi = new AssessmentApi(c);
        this.subscriber=userState.subscribe(s=>{
            this.currentUserState=s;
        });
        onDestroy(this.subscriber);
    }
    private AUTH_TOKEN_NAME="auth-token";
    private StoreAuthToken(token: AuthenticationResponse): void
    {
        localStorage.setItem(this.AUTH_TOKEN_NAME,JSON.stringify(token));
    }
    private RemoveAuthToken():void{
        localStorage.removeItem(this.AUTH_TOKEN_NAME);
    }
    private GetCachedAuthToken(): AuthenticationResponse
    {
        const token = localStorage.getItem(this.AUTH_TOKEN_NAME);
        if(!!token)
            return JSON.parse(token);
        else
            return null;
    }

    private SetLoggedIn(token: AuthenticationResponse): void
    {
        this.StoreAuthToken(token);
        userState.update(u=>{
            u.isLoggedIn=true;
            u.accessMode=token.accessMode;
            u.email=token.email;
            return u;
        })
    }

    private SetLoggedOut(){
        this.RemoveAuthToken();
        userState.update(u=>{
            u.isLoggedIn=false;
            return u;
        })
    }

    private GetRequestInit(): RequestInit {
        const defaultHeaders = [
            ["Content-Type", "application/json"]
        ];
        let authHeaders=[];
        var storedToken = this.GetCachedAuthToken();
        if(!!storedToken)
        {
            authHeaders=[["Authorization", "Bearer " + storedToken.token]];
        }
        return {
            credentials: "include",
            headers: [...defaultHeaders,...authHeaders]
        }
    }



    private async TryRefreshToken():Promise<LoginResponse>
    {
        //const cachedToken = this.GetCachedAuthToken();
        let retval:LoginResponse={success:false, data: null};
        //if(!!cachedToken)
        //{
        //    await this.authApi.refresh(this.GetRequestInit())
        //    .then(v=>{
        //        this.SetLoggedIn(v);
        //        retval={ success: true, data: { accessMode: v.accessMode } }
        //    })
        //}
        return retval;
    }
    private async TryLogin(email: string, password: string):Promise<LoginResponse>
    {
        let retval: LoginResponse={success: false, data: null};
        await this.authApi.authenticate({authenticationRequest:{email:email, password: password}})
                    .then(response=>{
                        this.SetLoggedIn(response)
                        retval= { success: true, data: { accessMode: response.accessMode } };
                    })
                    .catch(e=>{
                        this.SetLoggedOut();
                        retval= { success: false, message: 'Either the email address or OTP do not match.' } 
                    })
        return retval;
     }

    public async LoginAsync(email: string, password: string): Promise<LoginResponse> {
        let loginResult = await this.TryRefreshToken();
        if(!loginResult.success)
        {
            loginResult=await this.TryLogin(email,password);
        }
        return loginResult;
    }

    public async GetAssessmentAsync(): Promise<GetAssessmentResponse> {
        try {
            var result = await this.assessmentApi.getAssessmentByUser(this.GetRequestInit());
            if (result) {

                return {
                    success: true,
                    data: result
                };
            } else {
                return { success: false }
            }
        } catch (e) {
            return { success: false, message: e.message }
        }
    }

    public async UpdateAssessmentAsync(assessment: Assessment): Promise<UpdateAssessmentResponse> {
        try {
            const result = await this.assessmentApi.updateAssessmentById({ id: assessment.id, assessment: assessment }, this.GetRequestInit());
            return { success: true, data: result };
        } catch (e) {
            return { success: false, message: e.message };
        }

    }

    public async RequestOtpAsync(email: string): Promise<OtpResponse> {
        try {
            await this.authApi.apiAuthenticateOtpEmailPost({ email: email })
            return { success: true };
        } catch (e) {
            return { success: false, message: e.message }
        }
    }
    public async StoreHipaaAsync(assessmentId: string): Promise<StoreHipaaResponse> {
        try {
            await this.assessmentApi.storeHipaaConsentPDF({ id: assessmentId }, this.GetRequestInit());
            return { success: true };
        } catch (e) {
            return { success: false, message: e.message }
        }

    }

    public async CalculateResultsAsync(assessmentId: string): Promise<RequestCalculateResultsResponse> {
        try {
            await this.assessmentApi.calculateResults({ id: assessmentId }, this.GetRequestInit());
            return { success: true };
        } catch (e) {
            return { success: false, message: e.message }
        }
    }
    public async CheckResultsStatusAsync(assessmentId: string): Promise<CheckResultsStatusResponse> {
        let response = await this.assessmentApi.getResultsStatus({ id: assessmentId }, this.GetRequestInit());

        return { success: true, data: response };
    }

    public get isLoggedIn() {
        return this.currentUserState.isLoggedIn;
    }
}